export enum LogoSize {
  COMPACT = 'compact',
  DEFAULT = 'default',
}
